var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "full-header borderBottom"
  }, [_vm.technicalWorkMessage ? _c('div', {
    ref: "techMessage",
    staticClass: "tech-message text-center body-2 py-3 px-4"
  }, [_vm._v(" " + _vm._s(_vm.technicalWorkMessage) + " ")]) : _vm._e(), _c('div', {
    staticClass: "header background"
  }, [_c('router-link', {
    staticClass: "d-flex td-none",
    attrs: {
      "to": "/"
    }
  }, [_c('v-img', {
    staticClass: "logo",
    attrs: {
      "src": require('@/assets/logo.png')
    }
  }), _c('v-toolbar-title', {
    staticClass: "toolbar-text accent--text"
  }, [_vm._v(" Сервис восстановления и перевода"), _c('br'), _vm._v(" из других образовательных организаций ")])], 1), _c('v-spacer'), !_vm.isSmAndDown ? _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('div', {
    staticClass: "my-2 mr-2"
  }, [_c('v-btn', {
    staticClass: "lightGrey--text px-3",
    class: {
      'mr-1': !_vm.username
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.$emit('openContactsDialog');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-phone-outline")])], 1)], 1), _c('div', {
    staticClass: "my-2"
  }, [_c('v-btn', {
    staticClass: "lightGrey--text px-3",
    class: {
      'mr-1': !_vm.username
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.$emit('openHelpDialog');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-help-circle-outline")])], 1)], 1), _vm.username ? _c('div', {
    staticClass: "pr-1"
  }, [_c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-btn', _vm._g({
          staticClass: "pr-3 pl-3 show-login-menu",
          attrs: {
            "text": "",
            "color": "grey",
            "title": _vm.username
          }
        }, on), [_c('v-icon', {
          staticClass: "lightGrey--text mr-0",
          attrs: {
            "left": "",
            "size": "24"
          }
        }, [_vm._v("mdi-account-outline")]), _c('v-icon', {
          staticClass: "lightGrey--text ml-0",
          attrs: {
            "right": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.loginMenu ? 'mdi-chevron-up' : 'mdi-chevron-down') + " ")])], 1)];
      }
    }], null, false, 1744570862),
    model: {
      value: _vm.loginMenu,
      callback: function callback($$v) {
        _vm.loginMenu = $$v;
      },
      expression: "loginMenu"
    }
  }, [_c('v-list', {
    staticClass: "py-0"
  }, [_c('v-list-item', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-title', {
    staticClass: "lightGrey--text body-2 v-list-username"
  }, [_vm._v(" " + _vm._s(_vm.username) + " ")])], 1), _c('v-divider'), _c('v-divider'), _c('v-list-item', {
    attrs: {
      "dense": ""
    },
    on: {
      "click": _vm.openPersonalCard
    }
  }, [_c('v-list-item-title', {
    staticClass: "accent--text body-1 pointer"
  }, [_vm._v(" Личные данные ")])], 1), _c('v-divider'), _c('v-list-item', {
    attrs: {
      "dense": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('v-list-item-title', {
    staticClass: "accent--text body-1 pointer"
  }, [_vm._v(" Выйти ")])], 1)], 1)], 1)], 1) : _vm._e()]) : _c('div', {
    staticClass: "hamburger",
    class: {
      'active': _vm.activeMenu
    },
    on: {
      "click": _vm.hamburgerClick
    }
  }, [_c('span'), _c('span'), _c('span')])], 1)]), _vm.isSmAndDown ? _c('div', {
    ref: "mobileMenu",
    staticClass: "mobile-menu",
    class: {
      'active': _vm.activeMenu
    }
  }, [_c('div', {
    staticClass: "mt-2"
  }, [_vm.username ? _c('MenuLinks', {
    attrs: {
      "links": _vm.links,
      "isMobile": true
    }
  }) : _vm._e(), _c('div', {
    staticClass: "my-2"
  }, [_c('v-btn', {
    staticClass: "lightGrey--text px-3",
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.$emit('openHelpDialog');
      }
    }
  }, [_vm._v(" Помощь ")])], 1), _vm.username ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on;
        return [_c('v-btn', _vm._g({
          staticClass: "px-3",
          attrs: {
            "text": "",
            "color": "grey"
          }
        }, on), [_c('span', {
          staticClass: "lightGrey--text"
        }, [_vm._v(_vm._s(_vm.username))]), _c('v-icon', {
          attrs: {
            "color": "lightGrey",
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)];
      }
    }], null, false, 2468927017)
  }, [_c('v-list-item', {
    attrs: {
      "dense": ""
    },
    on: {
      "click": _vm.openPersonalCard
    }
  }, [_c('v-list-item-title', {
    staticClass: "accent--text body-1 pointer"
  }, [_vm._v(" Личные данные ")])], 1), _c('v-divider'), _c('v-list', [_c('v-list-item', {
    attrs: {
      "dense": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('v-list-item-title', {
    staticClass: "accent--text body-1 pointer"
  }, [_vm._v(" Выйти ")])], 1)], 1)], 1) : _vm._e()], 1)]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }